import { render, staticRenderFns } from "./ShopAlbum.vue?vue&type=template&id=d3873a42&scoped=true&"
import script from "./ShopAlbum.vue?vue&type=script&lang=js&"
export * from "./ShopAlbum.vue?vue&type=script&lang=js&"
import style0 from "./ShopAlbum.vue?vue&type=style&index=0&id=d3873a42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3873a42",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VApp,VSelect})
